import React, { useCallback } from 'react';
import prettysize from 'prettysize';
import { Button } from "reactstrap";
import { useApp, useFilePicker, usePreviewComponent } from "react-admin-base";
import { FormattedMessage } from "react-intl";
var photo_ext = ["png", "jpg", "jpeg", "svg"];
function is_photo(name) {
    return photo_ext.indexOf(name.split('.')[1]) !== -1;
}
function is_absolute(url) {
    if (url.indexOf("blob:") === 0)
        return false;
    var pat = /^https?:\/\//i;
    return !pat.test(url);
}
export function Relative({ children }) {
    const app = useApp();
    if (!children)
        return null;
    const { src, href } = children.props;
    return React.cloneElement(children, {
        src: src && (is_absolute(src) ? app.endpoint.replace(/\/$/, "") + src : src),
        href: href && (is_absolute(href) ? app.endpoint.replace(/\/$/, "") + href : href)
    });
}
export function Preview({ value }) {
    var name = value.$name;
    var src = value.$blob_url || value.$src;
    if (is_photo(name)) {
        return React.createElement("div", { className: "mt-2" },
            React.createElement(Relative, null,
                React.createElement("img", { src: src, style: { maxHeight: '150px', maxWidth: '100%' }, alt: name })));
    }
    return null;
}
export default function FilePickerCore({ disabled, className, accepts, value, onNotify, children, transform }) {
    const [uc, cancel, pick] = useFilePicker(value, onNotify);
    const CustomPreview = usePreviewComponent() || Preview;
    const chooseFile = useCallback(function (e) {
        e.preventDefault();
        pick(accepts, transform);
    }, [pick, accepts, transform]);
    if (uc.$state === 1) { // dosya sec
        return React.createElement("div", { className: className },
            React.createElement(Button, { color: "primary", size: "sm", onClick: chooseFile, disabled: disabled },
                React.createElement("i", { className: "fa fa-upload" }),
                " ",
                React.createElement(FormattedMessage, { id: "CHOOSE_FILE" })),
            children && children(null));
    }
    else if (uc.$state === 2) { // yukleniyor
        return React.createElement("div", { className: className },
            React.createElement(Button, { color: "danger", outline: true, size: "sm", onClick: cancel },
                React.createElement("i", { className: "fa fa-times-circle" })),
            ' ',
            React.createElement(Button, { disabled: true, size: "sm", outline: true, color: "dark" },
                React.createElement("i", { className: "fa fa-spinner fa-spin" }),
                React.createElement("span", { style: { width: '35px', display: 'inline-block' } },
                    Math.round(uc.$pr * 1000) / 10,
                    "%"),
                uc.name),
            children && children(uc));
    }
    else if (uc.$state === 3) { // yuklendi
        return React.createElement("div", { className: className },
            !disabled && React.createElement(Button, { color: "danger", outline: true, size: "sm", onClick: cancel },
                React.createElement("i", { className: "fa fa-trash" })),
            "\u00A0",
            React.createElement(Relative, null,
                React.createElement("a", { href: uc.$src, target: "_blank", className: "btn btn-sm btn-outline-primary" },
                    React.createElement("i", { className: "fa fa-download" }),
                    " ",
                    uc.name)),
            React.createElement("span", null,
                "\u00A0(",
                prettysize(uc.$size),
                ")"),
            React.createElement(CustomPreview, { value: uc }),
            children && children(uc));
    }
    return null;
}
